require('slick-carousel');
const $ = jQuery;

if($('.hero-slideshow').length) {

    $('.hero-slideshow').slick({
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 5000
    });

}
